/**
 * Login Button Component
 * Google sign-in (upgrades the current guest in place) + continue-as-guest.
 */

import { useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'

export const LoginButton = () => {
  const { signInAsGuest, signInWithGoogle, upgrading } = useAuth()
  const [guestLoading, setGuestLoading] = useState(false)

  const handleGoogle = async () => {
    try {
      await signInWithGoogle()
    } catch (error) {
      console.error(error)
    }
  }

  const handleGuestSignIn = async () => {
    setGuestLoading(true)
    try {
      await signInAsGuest()
    } catch (error) {
      console.error(error)
    } finally {
      setGuestLoading(false)
    }
  }

  return (
    <div className="flex flex-col gap-3 w-full max-w-sm font-jakarta">
      <button
        onClick={handleGoogle}
        disabled={upgrading}
        className="w-full flex items-center justify-center gap-3 px-6 py-3 bg-white border border-ink/[.15] text-ink rounded-full font-bold hover:border-paiseh-orange transition-colors disabled:opacity-50 disabled:cursor-not-allowed shadow-sm"
      >
        <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#EA4335" d="M12 10.2v3.9h5.5c-.24 1.4-1 2.6-2.1 3.4v2.8h3.4c2-1.8 3.1-4.5 3.1-7.7 0-.7-.06-1.4-.18-2.1H12z" />
          <path fill="#34A853" d="M12 22c2.7 0 5-.9 6.7-2.4l-3.4-2.6c-.9.6-2 1-3.3 1-2.6 0-4.7-1.7-5.5-4.1H3v2.6C4.7 19.8 8.1 22 12 22z" />
          <path fill="#FBBC05" d="M6.5 13.9c-.2-.6-.3-1.2-.3-1.9s.1-1.3.3-1.9V7.5H3A10 10 0 0 0 2 12c0 1.6.4 3.2 1 4.5l3.5-2.6z" />
          <path fill="#4285F4" d="M12 6c1.5 0 2.8.5 3.8 1.5l2.9-2.9C16.9 2.9 14.7 2 12 2 8.1 2 4.7 4.2 3 7.5l3.5 2.6C7.3 7.7 9.4 6 12 6z" />
        </svg>
        {upgrading ? 'Signing in…' : 'Continue with Google'}
      </button>

      <button
        onClick={handleGuestSignIn}
        disabled={guestLoading}
        className="w-full px-6 py-3 bg-ink text-cream rounded-full font-bold hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {guestLoading ? 'Signing in…' : 'Continue as guest'}
      </button>

      <p className="text-xs text-paiseh-faint text-center mt-1">
        Guest lists live in this browser. Sign in with Google to keep them safe and
        access them anywhere.
      </p>
    </div>
  )
}
